module.exports = __webpack_public_path__ + "img/datosestancia.ad20502b.png";